import * as fromDashboard from '../actions/dashboard.action';

export interface FreelancerState {
  data: any,
  loading: boolean;
  loaded: boolean;
  error: string;
}

export const initialState = {
  data:null,
  loading:false,
  loaded: true,
  error: null
};

export function reducer(state = initialState, action: fromDashboard.DashboardAction): FreelancerState {
  switch (action.type) {
    case fromDashboard.GET_DASHBOARD_DETAILS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromDashboard.GET_DASHBOARD_DETAILS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        error: null
      };
    }
    case fromDashboard.GET_DASHBOARD_DETAILS_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        data: null,
        error: action.payload
      };
    }

  }
  return state;
}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/dashboard/store/reducers/dashboard.reducer.ts